import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { Controller } from "react-hook-form";
import { FaStarOfLife } from "react-icons/fa";

export default function SelectField({
  icon,
  label,
  isRequired,
  error,
  name,
  options = [],
  className = "",
  parentClassName = "",
  isMulti = false,
  control,
  ...rest
}) {
  return (
    <div className={parentClassName}>
      <label className="flex items-center gap-2 mb-1 text-lg text-gray-800">
        {icon}
        {label}
        {isRequired && <FaStarOfLife className="text-red-800 text-[6px]" />}
      </label>

      {control && (
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Select
              {...field}
              {...rest}
              options={options}
              isMulti={isMulti}
              classNamePrefix="react"
              className={`react-select-container ${className}`}
              onChange={(selected) => {
                field.onChange(isMulti ? selected.map((option) => option.value) : selected?.value || "");
              }}
              value={
                isMulti
                  ? options.filter((option) => field.value?.includes(option.value))
                  : options.find((option) => option.value === field.value)
              }
            />
          )}
        />
      )}

      {error && <p className="text-red-600 text-sm mt-1">{error.message}</p>}
    </div>
  );
}

SelectField.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
  parentClassName: PropTypes.string,
  isMulti: PropTypes.bool,
  control: PropTypes.object.isRequired,
};
